import { isContainer } from '@framework/engine/schema/widgets/repository/containers/IContainerWidget.ts';
import {
  type Widget,
  WidgetType,
} from '@framework/engine/schema/widgets/Widget.ts';
import { type ColProps } from 'antd';
import { sum } from 'lodash';
import React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import { WidgetColumnWrapper } from './WidgetColumn.styled.tsx';

/**
 * Se il parent non ha children o non è un container ritorna 100.
 * Se il parent _non_ è una row, ritorna 100.
 * Altrimenti se è una row calcola la larghezza in base al colspan indicato.
 */
export function getColumnPercentWidth(parent?: Widget) {
  if (!parent || !isContainer(parent) || !parent.children) return 100;
  if (parent.type !== WidgetType.Row) return 100;
  const colNumbers = sum(
    parent.children.map(child => Number(child.layout?.colSpan ?? 1)),
  );
  return 100 / colNumbers;
}

export interface IWidgetColumnProps extends ColProps {
  parent?: Widget;
  widget?: Widget;
  children?: React.ReactNode;
}

/**
 * Elemento Colonna posizionato intorno al Widget che permette il ridimensionamento.
 * Memoizzato per evitare re-render quando il parent (FillableWidgetList) re-rende
 * ma le props sono stabili.
 */
export const WidgetColumn = React.memo(function WidgetColumn(
  props: IWidgetColumnProps,
) {
  const { children, parent, widget } = props;
  const isMobile = useBreakpoint(down('sm'));

  const width = isMobile
    ? 100
    : (widget?.layout?.colSpan ?? 1) * getColumnPercentWidth(parent);

  return <WidgetColumnWrapper width={width}>{children}</WidgetColumnWrapper>;
});
